<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title>Clientes - Mi Portafolio</mat-card-title>

        <div class="spinner">
            <mat-spinner [diameter]="60" *ngIf="booleanFlag"></mat-spinner>
        </div>

        <div class="table-responsive" style="margin-top: 12px;" [class.esconder]="booleanFlag == true">
            <table mat-table [dataSource]="dataSource" [class.esconder]="booleanText == true">
                <ng-container matColumnDef="companyName">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Nombre
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="linkable" [routerLink]="['/dashboards/files-clients']" [queryParams]="{client: element.companyId}">
                            {{element.companyName || '-'}}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="companyRut">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Rut
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{element.companyRut}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sellAvgInvoices">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Monto Promedio ventas
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{(element.sellAvgInvoices ||0) | currency:'CLP':'symbol'}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="totalSellInvoices">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Facturas vendidas
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{element.totalSellInvoices}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="siiConnect">
                    <th mat-header-cell *matHeaderCellDef>
                      <img
                        src="/assets/images/logos/Logo_de_Servicio_de_Impuestos_Internos.svg"
                        alt="google"
                        width="18"
                      />
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-body-1">
                      <i-tabler
                        *ngIf="element.siiConnect == true"
                        name="circle-check-filled"
                        class="icon-20"
                        style="color: mediumspringgreen"
                      ></i-tabler>
          
                      <i-tabler
                        *ngIf="element.siiConnect == false"
                        name="circle-x-filled"
                        class="icon-20"
                        style="color: red"
                      ></i-tabler>
                    </td>
                  </ng-container>
          
                  <ng-container matColumnDef="favorite">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Favorito
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-body-1">
                        <div class="clickable-section" (click)="clickToMarkOrUnmarkCompanyAssignmentAsFavorite(element)">
                            <i-tabler  name="star-filled"
                            [style.color]="element.favorite ? 'darkorange': 'lightgrey'"                        
                                class="icon-20">
                            </i-tabler>    
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
            </table>
            <mat-paginator (page)="receiveChangePaginator($event)" [pageSizeOptions]="[10, 20, 50, 100]" [class.esconder]="booleanText == true"></mat-paginator>
        </div>

        <div *ngIf="booleanText" style="text-align: center;">
            <h3>Portafolios sin Clientes</h3>
        </div>

    </mat-card-content>
</mat-card>